import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle, Check } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Academy = ({ waLink }) => {
  const { t } = useLanguage();
  const a = t.academy;
  return (
  <section id="academy" className="py-24 lg:py-32" data-testid="academy-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="glass-panel spotlight rounded-3xl p-10 sm:p-14 relative overflow-hidden"
      >
        <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-neon-cyan/20 blur-[100px] pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full bg-neon-magenta/20 blur-[100px] pointer-events-none" />

        <div className="relative grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-xs font-bold tracking-[0.3em] uppercase text-neon-cyan mb-4">{a.overline}</p>
            <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-tight">
              {a.titleA} <span className="neon-text">{a.titleNeon}</span>
            </h2>
            <p className="mt-6 text-base lg:text-lg text-white/70">{a.subtitle}</p>
            <ul className="mt-8 flex flex-col gap-3">
              {a.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm text-white/80">
                  <Check size={16} className="text-neon-cyan mt-0.5 shrink-0" /> {b}
                </li>
              ))}
            </ul>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="/academy"
                data-testid="academy-cta-course"
                className="flex items-center gap-2 btn-cyber bg-gradient-to-r from-neon-cyan to-neon-violet px-8 py-4 font-semibold text-void hover:opacity-90 hover:-translate-y-0.5 transition-all duration-300"
              >
                {a.ctaPrimary} <ArrowUpRight size={18} />
              </a>
              <a
                href={waLink(a.waMessage)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="academy-cta-whatsapp"
                className="flex items-center gap-2 btn-cyber border border-white/20 px-8 py-4 font-semibold hover:border-neon-cyan/60 hover:text-neon-cyan hover:-translate-y-0.5 transition-all duration-300"
              >
                <MessageCircle size={18} /> {a.ctaSecondary}
              </a>
            </div>
          </div>

          <div className="grid grid-cols-5 gap-3">
            {Array.from({ length: 10 }, (_, i) => (
              <div
                key={i}
                className="aspect-square rounded-xl border border-white/10 bg-white/[0.03] flex items-center justify-center font-mono text-neon-cyan/80 text-sm sm:text-base hover:border-neon-cyan/50 hover:bg-neon-cyan/5 transition-colors duration-300"
              >
                {String(i + 1).padStart(2, "0")}
              </div>
            ))}
            <p className="col-span-5 text-center text-xs tracking-[0.25em] uppercase text-white/40 mt-2">{a.lessonsLabel}</p>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
  );
};

export default Academy;
